import * as React from "react"
import { connect } from "react-redux"

import {
    InlineAttachment,
    ToolboxAttachments,
} from "@tenforce/toolbox-attachments-react"

import { toBase64, isImage } from "../../../util/File"
import { GlobalState } from "../../../store"
import { Labels } from "../../../util/Translations"

import { mapDispatchToProps, DispatchProps } from "../actions"
import { ISelectedDocument } from "../index"

interface OwnProps {
    ipfValue: File[]
    ipfName: string
}

interface StateProps {
    fullName: string
}

type Props = OwnProps & StateProps & DispatchProps

interface State {
    selectedDocuments: ISelectedDocument[]
}

export class CNIInlineAttachment extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            selectedDocuments: [],
        }
    }

    render(): JSX.Element {
        const { ipfName } = this.props

        return (
            <InlineAttachment
                cardWrapperClasses="tw-p-2 tw-w-full md:tw-w-1/2 lg:tw-w-1/3"
                attachmentsPrivs={{
                    canAdd: true,
                    canDelete: true,
                    canEditDescription: true,
                }}
                maxInitialCards={9}
                fieldName={ipfName}
                attachments={this.state.selectedDocuments.map(
                    this.toAttachment,
                )}
                attachmentsActions={{
                    loadCounter: -1,
                    shouldShowAll: true,
                    onDelete: this.onDeleteAttachment,
                    onAdd: this.onAddAttachment,
                    onUpdateDescription: this.onUpdateAttachmentDescription,
                }}
                labels={{
                    openImageInNewTab: Labels.OpenImageInANewTab,
                    addDescriptionHere: Labels.AddDescriptionHere,
                    browseDropFilesHere: Labels.BrowseDropFilesHere,
                    deleteThisAttachment: Labels.Delete,
                    dropItAs: Labels.DropItAs,
                    loadNMore: Labels.LoadNMore,
                }}
            />
        )
    }

    toAttachment = (
        document: ISelectedDocument,
    ): ToolboxAttachments.Attachment => ({
        creator: this.props.fullName,
        fileProperties: document.fileSize,
        id: document.key,
        fileName: document.file.name,
        thumbnail: document.thumbnail,
        description: document.description,
        // there is no url yet because these files are not uploaded
        url: "",
    })

    keyCounter = 0

    onAddAttachment = async (request: UploadRequest): Promise<void> => {
        const addedAttachment: ISelectedDocument = {
            fileSize: (request.file.size / 1024).toFixed(2) + "KB",
            key: this.keyCounter++,
            thumbnail: isImage(request.file.name)
                ? await toBase64(request.file)
                : undefined,
            file: request.file,
            description: "",
        }

        this.setState(({ selectedDocuments }) => {
            const newSelectedDocuments = [addedAttachment, ...selectedDocuments]

            this.props.ipfValue.splice(
                0,
                this.props.ipfValue.length,
                ...newSelectedDocuments.map((a) => a.file),
            )

            return {
                selectedDocuments: newSelectedDocuments,
            }
        })
    }

    onDeleteAttachment = async (key: number): Promise<void> => {
        const { selectedDocuments } = this.state

        const newSelectedDocuments = selectedDocuments.filter(
            (a) => a.key !== key,
        )

        this.props.ipfValue.splice(
            0,
            this.props.ipfValue.length,
            ...newSelectedDocuments.map((a) => a.file),
        )

        this.setState({ selectedDocuments: newSelectedDocuments })
    }

    onUpdateAttachmentDescription = async (
        key: number,
        value: string,
    ): Promise<void> => {
        const newSelectedDocuments = this.state.selectedDocuments.map(
            (attachment) => {
                if (attachment.key === key) {
                    attachment.description = value
                }
                return attachment
            },
        )
        this.setState({ selectedDocuments: newSelectedDocuments })
    }
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    fullName: state.userInfo.fullName,
})

export default connect(mapStateToProps, mapDispatchToProps)(CNIInlineAttachment)
